// extracted by mini-css-extract-plugin
module.exports = {"page":"styles_page___LAfq","main_content":"styles_main_content__3SCug","photo_schema":"styles_photo_schema__2XAKZ","content_list":"styles_content_list__r7Z3X"};